import { Box, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ValidationTextFieldColor } from 'src/utils/theme';

export const ValidationTextField = styled(TextField)(
  ({ theme, status }) => `
    width: 100%;
    border-width: 1;
    border-color: ${
      status === 'input'
        ? theme.palette.primary.main
        : ValidationTextFieldColor(status)
    };
    background: ${theme.palette.primary.contrastText};
    border-radius: 0.25rem;

    .Mui-disabled {
      background-color: ${theme.palette.brand.disabled};
    }
    .MuiFormHelperText-filled {
      background-color: transparent;
    }
    .MuiOutlinedInput-root fieldset {
      border-color: ${
        status === 'input'
          ? theme.palette.primary.main
          : ValidationTextFieldColor(status)
      };
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.palette.primary.main}
    }

    .MuiInputBase-input {
      font-weight: 300;
    }
  `,
);

export const InputWrapper = styled(Box)(
  () => `
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 6px;
`,
);
